/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useSearchParams } from "react-router";
import { useAuth } from '@/commons/auth';
import FormTambahDosenKelas from '../components/FormTambahDosenKelas'

import getDosen from '../services/getDosen'
const TambahDosenKelasPage = props => {
const { id, kelasId } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	tambahDosenKelas: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [dosen, setDosen] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, tambahDosenKelas: true}))
		const { data: dosenResponse } = await getDosen({   })

	    setDosen(dosenResponse.data)


	    setIsLoading(prev => ({...prev, tambahDosenKelas: false}))
    }
	if (checkPermission("CreateKelasDosen")) { 
		fetch()
	}
  }, [])

	
	useEffect(() => {
		setTitle("Tambah Dosen Kelas Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/kelas/${kelasId}
			  	`}>
			  		<Button id="_ihfHIC55EfCJ1YDat3KRPQ" className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
{ checkPermission("CreateKelasDosen") && ( 
	<Layouts.FormContainerLayout
		singularName={"Dosen"}
		isLoading={isLoading.tambahDosenKelas}
	>
		{dosen ? 
		(<>
		 <FormTambahDosenKelas
			{...{ 
				dosen
				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>

)}

	</Layouts.ViewContainerLayout>
  )
}
export default TambahDosenKelasPage

